import { useState } from "react";
import { Form, Dropdown } from "react-bootstrap";
import './NewRagForm.css';

interface Option {
    label: string;
    value: string;
}

interface Props {
    label: string;
    name: string;
    value: string[];             // <-- multiple values
    options: Option[];
    required?: boolean;
    disabled?: boolean;
    onChange: (key: string, values: string[]) => void;
}

const SelectWithCheckbox = ({
    label,
    name,
    value,
    options,
    required,
    disabled,
    onChange
}: Props) => {
    const [open, setOpen] = useState(false);

    const toggleValue = (val: string) => {
        const newValues = value.includes(val)
            ? value.filter((v) => v !== val)
            : [...value, val];

        onChange(name, newValues);
    };

    return (
        <Form.Group>
            <Form.Label>
                {label} {required && <span className="text-danger">*</span>}
            </Form.Label>
             {/* Hidden input so browser can do required validation */}
             <input
                type="text"
                tabIndex={-1}
                autoComplete="off"
                required={required}
                value={value?.length > 0 ? value?.join(",") : []}
                onChange={() => {}}
                style={{
                    opacity: 0,
                    height: 0,
                    padding: 0,
                    margin: 0,
                    // position: "absolute",
                    pointerEvents: "none"
                }}
            />

            <Dropdown show={open} onToggle={() => setOpen(!open)} className="MultiSelectBox_container">
                <Dropdown.Toggle
                    variant="light"
                    disabled={disabled}
                    className="w-100 form-select  text-start"
                    // className="w-100 text-start border border-secondary"
                >
                    {value.length === 0 ? "Select options" : value?.join(", ")}
                </Dropdown.Toggle>

                <Dropdown.Menu className="w-100">
                    {options?.map((opt) => (
                        <div
                            key={opt.value}
                            className="dropdown-item d-flex align-items-center gap-2"
                        >
                            <Form.Check
                                type="checkbox"
                                checked={value.includes(opt.value)}
                                onChange={() => toggleValue(opt.value)}
                                label={opt.label}
                            />
                        </div>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        </Form.Group>
    );
};

export default SelectWithCheckbox;
